import EntertainmentModel       from '@models/shop/EntertainmentModel';
import ProductStatusModel       from '@models/shop/ProductStatusModel';
import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import ShopServiceModel         from '@/models/ShopServiceModel';
import TimestampAble            from '@widesk-core/models/traits/TimestampAble';
import Blamable                 from '@/models/traits/Blamable';
import Translatable             from '@widesk-core/models/traits/Translatable';
import { RenderNameProps }      from '@widesk-ui/mixins/ApiModelRenderName';
import WithEntertainmentPath    from '@/models/mixins/withEntetainmentPath';
import ExpirationTypeModel      from '@models/shop/ExpirationTypeModel';
import ProductTypeModel         from '@models/shop/ProductTypeModel';
import VatModel                 from '@models/shop/VatModel';
import getConfig                from '@/helpers/getConfig';
import ProductGroupModel        from '@models/shop/ProductGroupModel';
import ProductSalesStatusModel  from '@models/shop/ProductSalesStatusModel';
import DeliverableTemplateModel from '@models/shop/DeliverableTemplateModel';
import TaxonomyModel            from '@models/shop/TaxonomyModel';
import { computed }             from 'mobx';

const customDoc = doc;

@model.urnResource('product')
@doc.path('/products/{?id}')
export default class ProductModel extends Blamable(TimestampAble(Translatable(WithEntertainmentPath(ShopServiceModel), {
	'title': true,
	'description': true,
	'shortDescription': true,
	'badgeInformation': true,
	'termsOfUse': true,
	'instructionsOnTicket': true,
}))) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'endDate[after]': string | Date | Dayjs;
		'endDate[before]': string | Date | Dayjs;
		'endDate[strictly_after]': string | Date | Dayjs;
		'endDate[strictly_before]': string | Date | Dayjs;
		'entertainment': id;
		'entertainment.entertainmentUrn': Urn;
		'mainTaxonomy': id;
		'manualValidation': '0' | '1';
		'multiVariant': '0' | '1';
		'onlySoldInBundle': '0' | '1';
		'productSalesStatus': id;
		'productSalesStatus.reference': Shop_ProductSalesStatusReference;
		'productStatus': id;
		'productStatus.reference': Shop_ProductStatusReference;
		'productProductSets.productSet': id;
		'productTaxonomies.taxonomy': id;
		'productType': id;
		'productType.reference': Shop_ProductTypeReference;
		'slug': id;
		'startDate[after]': string | Date | Dayjs;
		'startDate[before]': string | Date | Dayjs;
		'startDate[strictly_after]': string | Date | Dayjs;
		'startDate[strictly_before]': string | Date | Dayjs;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'endDate': string;
		'entertainment.label': string;
		'id': string;
		'position': string;
		'startDate': string;
		'translations.title': string;
		'updatedAt': string;
	};

	@doc.number declare bankDelay: number;
	@doc.model(DeliverableTemplateModel) declare deliverableTemplate: DeliverableTemplateModel;
	@doc.date declare endDate: Dayjs;
	@doc.model(EntertainmentModel) declare entertainment: EntertainmentModel;
	@doc.model(ExpirationTypeModel) declare expirationType: ExpirationTypeModel;
	@doc.boolean declare manualValidation: boolean;
	@doc.number declare maxQuantity: number;
	@doc.number declare maxQuantityPerOrder: number;
	@doc.boolean declare multiVariant: boolean;
	@doc.boolean declare onlySoldInBundle: boolean;
	@doc.number declare position: number;
	@doc.model(ProductGroupModel) declare productGroup: ProductGroupModel;
	@doc.model(ProductSalesStatusModel) declare productSalesStatus: ProductSalesStatusModel;
	@doc.model(ProductStatusModel) declare productStatus: ProductStatusModel;
	@doc.model(ProductTypeModel) declare productType: ProductTypeModel;
	@doc.string declare slug: string;
	@doc.date declare startDate: Dayjs;
	@doc.model(VatModel) declare vat: VatModel;

	@customDoc.model(TaxonomyModel) declare mainTaxonomy: TaxonomyModel;

	public renderName(props?: RenderNameProps<this> & ProductNameProps) {
		return super.renderName(props);
	}

	static get prefix() {
		return '/produits/';
	}

	public get previewTicketingUrl() {
		return `${getConfig().ticketing_url}/preview/fr/evenements/${this.entertainment.slug}${ProductModel.prefix}${this.slug}`;
	}

	@computed get url() {
		return `${getConfig().ticketing_url}/fr/evenements/${this.entertainment.slug}${ProductModel.prefix}${this.slug}`;
	}
}